<template>
  <el-row justify="center" align="middle">
    <el-col :xs="24" :sm="12" :md="10" :lg="6" :xl="6" class="mt-5 pt-5">
      <el-card style="border-radius: 12px">
        <template #header>
          <div class="text-center">
            <img src="/kudenix-logo.png" class="img-cover" style="max-width: 120px" />
          </div>
        </template>
        <el-form label-position="top" :rules="rules" ref="ruleFormRef" :model="form">
          <el-form-item label="Email" prop="email">
            <el-input v-model="form.email"></el-input>
          </el-form-item>
          <el-form-item label="Contraseña" prop="password">
            <el-input v-model="form.password" :type="seePassword ? 'text' : 'password'">
              <template #append>
                <el-button @click="seePassword = !seePassword">Ver</el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <label>
              <el-checkbox v-model="form.rememberMe" class="pr-2 mr-2"></el-checkbox>
              Recordar dispositivo por un tiempo
            </label>
          </el-form-item>
        </el-form>
        <div class="text-end">
          <el-button text @click="router.push('/request-password')"> Recuperar contraseña </el-button>
          <el-button
            type="primary"
            size="large"
            class="px-5"
            @click="logInProcess"
            :loading="loading"
            >Iniciar Sesión</el-button
          >
          <br />
          <el-button text size="small" class="mt-3 d-none">Olvidé mi contraseña</el-button>
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { ElNotification } from 'element-plus'
import { logIn, rules as userRules } from '@/lib/user'
import { reactive, ref } from 'vue'

import { useUserStore } from '@/stores/user'
const userStore = useUserStore()

const router = useRouter()

const form = reactive({
  email: '',
  // email: 'megagod@kudenix.com',
  password: '',
  // password: '5Maug2020.',
  rememberMe: false
})

const rules = {
  email: userRules.email,
  password: [{ required: true, trigger: 'blur', message: 'Contraseña es requerida' }]
}

const seePassword = ref(false)
const loading = ref(false)
const ruleFormRef = ref(null)

const validate = async () => {
  const isValid = await ruleFormRef.value.validate(async (valid /*, fields */) => {
    if (valid) {
      return true
    } else {
      ElNotification.error(`Verifica el formulario`)
      return false
      // console.log('fields', fields)
    }
  })

  return isValid
}

const logInProcess = async () => {
  const valid = await validate()
  if (!valid) return
  loading.value = true
  const data = await logIn(form)

  if (data.error || !data.success) {
    loading.value = false
    return ElNotification.error('Error iniciando sesión')
  }

  await userStore.logIn(data)

  if (data.user.type === 'super') {
    router.push('/sa/agencies')
  } else if (data.user.type === 'product-loader') {
    const whereToGo = userStore.searchersLink
    router.push(whereToGo)
  } else {
    const whereToGo = '/dashboard'
    router.push(whereToGo)
  }
  loading.value = false
}
</script>
